<script setup>

const config = useRuntimeConfig()
const route = useRoute()

let blob_id = ref(route?.query?.blob_id ? parseInt(route?.query?.blob_id) : undefined)
let blobs = ref([])
let loading = ref(false)
let maxitems = ref(10)
let theme = ref('Blob')
// let active = ref('website')

const searchBlob = async function (query = '') {
  loading.value = true
  blobs.value = await $fetch(`/api/blob`, { query: { query }})
  loading.value = false
}
await searchBlob()

const code = computed(() => {
  if (blob_id.value) {
    return `<script src="${config.public.baseUrl}/blob-share.js" async defer></sc` + `ript>
<blob-share blob="${blob_id.value}" baseurl="${config.public.baseUrl}" theme="${theme.value}" maxitems="${maxitems.value}"></blob-share>`
  }
  return ''
})

watch(blob_id, (v) => {
  navigateTo({ query: { blob_id: blob_id.value }})
})

</script>

<template>
    <section>
      <h2>{{$t('embed.title')}}</h2>
      <p class="font-weight-light mb-6">{{ $t('embed.description') }}</p>
        <v-row>
          <v-col sm=6 md=5 lg=4>
            <client-only>
              <v-autocomplete color='indigo' @update:search='searchBlob' :label="$t('Blob')" name='blob'
                :items='blobs' :loading='loading' v-model='blob_id' item-value='id' item-title='name' item-subtitle="description" hide-no-data
                :placeholder="$t('blob.Blob to embed')" />
            </client-only>
          </v-col>
        </v-row>

      <!-- <v-tabs v-model='active'>
          <v-tab value='website'>{{$t('Website')}}</v-tab>
          <v-tab value='wordpress'>Wordpress</v-tab>
          <v-tab value='grav'>Grav</v-tab>
          <v-tab value='advanced'>Advanced</v-tab>
      </v-tabs> -->
        <!-- <v-window v-model='active'>
          <v-window-item active value='website'> -->
          <v-form v-show='blob_id'>
            <v-row>
              <v-col sm=6 md=5 lg=4>
                <!-- <v-switch color='primary' hide-details v-model="dark" label='Dark mode' />
                <v-switch color='primary' v-model="sidebar" label='Sidebar '/> -->
                <v-text-field type="number" v-model="maxitems" label="Max items"/>
                <v-select v-model="theme" label="Theme" :items="['Blob', 'Blob Dark', 'Sidebar', 'Sidebar Dark', 'Grid', 'Grid Dark']" />
              </v-col>
            </v-row>
            <div>
              <v-textarea class='font-weight-light text-body-2' rows=4 v-model='code' readonly />
              <v-sheet class='pa-6 rounded'>
                
              <!-- </v-sheet> :color='!dark ? "white" : "#222"'> -->
                <blob-share :blob='blob_id' :theme='theme'  :maxitems="maxitems"></blob-share>
              </v-sheet>
            </div>
          </v-form>
          <!-- </v-window-item>
          <v-window-item value='wordpress'>
            wordpress
          </v-window-item>
          <v-window-item value='grav'>
            grav
          </v-window-item>
          <v-window-item value='advanced'>
            <strong>API</strong>
          </v-window-item>
        </v-window> -->
    </section>
</template>
